'use strict';

var Backbone = require('backbone');
var _ = require('underscore');

export default Backbone.Model.extend({
  isType: function (type) {
    switch (type) {
      case 'text':
        return this.get('type') == 1;
      case 'select':
        return this.get('type') == 2;
      case 'checkbox':
        return this.get('type') == 3;
      case 'radio':
        return this.get('type') == 4;
      case 'textarea':
        return this.get('type') == 5;
      case 'upload':
        return this.get('type') == 6;
    }
  },
  // check question to make sure it has options if it is a type which requires them
  isValid: function () {
    return !((window.CONSTANTS.QUESTION_OPTIONABLE_TYPES.indexOf(this.get('type')) > -1) && (_.isEmpty(this.get('options'))));
  },
  hasServices: function (apptServiceIds) {
    return _.isEmpty(this.get('service_ids')) || !_.isEmpty(_.intersection(this.get('service_ids'), apptServiceIds));
  },
});
